// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-menu-item {
  cursor: pointer;
  padding: 5px 5px;
}
.dropdown-menu-item :hover {
  text-decoration: underline;
}

.dropdown-menu-items {
  padding: 5px 5px;
}

.dropdown-menu-box {
  border: 1px solid grey;
  width: -moz-max-content;
  width: max-content;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  position: absolute;
  background: white;
  right: 0;
  z-index: 1;
}

.dropdown-menu-button {
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/DropdownMenu/DropdownMenu.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,qBAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;AACJ;AAAI;EACI,0BAAA;AAER;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,4EAAA;EACA,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,UAAA;AACJ;;AAEA;EACI,eAAA;AACJ","sourcesContent":[".dropdown {\n    position: relative;\n    display: inline-block;\n}\n\n.dropdown-menu-item {\n    cursor: pointer;\n    padding: 5px 5px;\n    :hover {\n        text-decoration: underline;\n    }\n}\n\n.dropdown-menu-items {\n    padding: 5px 5px;\n}\n\n.dropdown-menu-box {\n    border: 1px solid grey;\n    width: max-content;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    position: absolute;\n    background: white;\n    right: 0;\n    z-index: 1;\n}\n\n.dropdown-menu-button {\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
